
import { css } from '@emotion/core';

import colors from '../config/colors';
import { mobileMediaQuery } from '../config/mediaQuery';


const modals = css`
  ${mobileMediaQuery} {
    .modal-content {
      border-radius: 8px !important;
    }
    .modal-title {
      font-family: Lato;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 0em;
      font-color: black;
    }
    .modal-open .modal-dialog {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: calc(100% - (#{$modal-dialog-margin} * 2));
      margin: auto;
      textarea {
        border-radius: 4px;
        border: 1px solid #DDE4EB;
        font-family: Lato;
      }
      input {
        height: 38px;
        border-radius: 4px;
        border: 1px solid #DDE4EB;
        font-family: Lato;
      }
      input:read-only  {
        background: #EDF0F1;
        border: 1px solid #DDE4EB;
      }
      label {
        color: black;
        text-align: left;
        line-height: 20px;
        font-weight: 500;
        font-family: Lato;
        font-size: 14px;
      }
      .input-label {
        margin: 0;
        font-family: Lato;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        color: black;
        width: 52px;
        padding-right: 5px;
      }
      .form-group {
        margin-bottom: 0;
      }
    }
    .columns-modal {
      height: 487px;
      overflow: scroll;
      .modal-body {
        height: 487px;
        overflow: scroll;
        & label {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
          & input {
            width: 16px;
            height: 16px;
            border-radius: 4px;
            margin: 0px;
            margin-right: 10px;
            border: 1px solid #D1D5DB;
          }
          & span {
            font-family: Lato;
            font-size: 14px;
            font-weight: 400;
            text-align: right;
          }
        }
      }
      .modal-footer {
        padding: 10px;
      }
    }
    .columns-top-button {
      font-family: Lato;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0em;
      text-align: right;
      color: ${colors.mobileGreen};
      background: none;
      border: none;
    }
    .columns-bottom-button-group {
      width: 100%;
      display: flex;
      justify-content: space-between;
      gap: 10px;
      & button {
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0em;
        text-align: right;
        background: none;
        width: 100%;
        height: 44px;
        text-align: center;
        padding: 12px 16px 12px 16px;
        border-radius: 4px;
        border: none;
      }
      & button:first-of-type {
        color: ${colors.mobileGreen};
      }
      & button:last-child {
        color: white;
        background-color: ${colors.mobileGreen};
      }
    }
    .accounts-notes-modal {
      .modal-body {
        padding: 0 15px 0 15px;
      }
      .modal-content {
        border-radius: 8px !important;
        width: 90%;
      }
      .modal-header {
        border: none;
      }
      textarea {
        height: 170px;
      }
      .modal-footer {
        border: none;
        padding: 10px 15px;
      }
    }
    .additional-info-modal {
      .modal-body {
        padding: 0 15px 0 15px;
        overflow: scroll;
        height: 50vh;
      }
      .modal-content {
        border-radius: 8px !important;
        width: 90%;
      }
      .modal-header {
        border-bottom: 1px solid #F1F1F1;
      }      
      .modal-footer {
        border: none;
      }
      p {
        font-family: Lato;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        color: #000000;
        margin-top: 5px;
        margin-bottom: 0px;
      }
      .modal-title {
        font-family: Lato;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
      }
    }
    .notes-modal {
      .modal-body {
        padding: 10px 20px;
      }
      .modal-footer {
        padding: 10px;
        border: none;
      }
      .modal-content {
        border-radius: 8px !important;
        width: 90%;
      }
      .modal-header {
        border: none;
      }
      .modal-title {
        font-family: Lato;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        text-align: left;
        color: black;
      }
      textarea {
        height: 79px;
      }
      .input-label {
        min-width: 52px;
      }
      @media (max-width: 500px) {
        .dropdown {
          .dropdown-menu {
            left: -90px;
            width: fit-content;
          }
          .dropdown-toggle {
            max-width: 250px;
            overflow: hidden;
          }
        }
      }
    }
    .inventory-notes-modal {
      .modal-content {
        width: 90%;
      }
      .modal-header {
        border-bottom: 1px solid #F1F1F1;
      }
      .modal-footer {
        border: none;
      }      
      .modal-body {
        height: 50vh;
        padding: 10px 20px;
        overflow: scroll;
      }
      p {
        font-family: Lato;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        color: #000000;
        margin-top: 5px;
        margin-bottom: 0px;
      }
    }
    .inventory-ratings-modal {
      .modal-content {
        width: 90%;
      }
      .modal-header {
        border-bottom: 1px solid #F1F1F1;
      }
      .modal-footer {
        border: none;
      }      
      .modal-body {
        height: 50vh;
        padding: 10px 20px;
        overflow: scroll;
      }
      p {
        font-family: Lato;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0em;
        color: #000000;
        margin-top: 5px;
        margin-bottom: 0px;
      }
    }
    .add-to-order-modal {
      .modal-content {
        width: 90%;
      }
      .modal-footer {
        border: none;
      }
      .label {
        height: 22px;
        padding: 4px 8px 4px 8px;
        border-radius: 16px;
      }
      .modal-multiple-fields-inline {
        display: flex;
        flex-direction: row;
        gap: 10px;
        justify-content: space-between;
      }
      .modal-counter-buttons-container {
        display: flex;
        flexDirection: row;
        gap: 10px;
        margin: 10px 0;
        width: 100%;
        justify-content: space-between;
      }
    }
    .counter-buttons {
      height: 35px;
      border-radius: 4px;
      border: 1px solid ${colors.mobileGreen};
      background: transparent;
      color: ${colors.mobileGreen};
      touch-action: manipulation;
      input {
        background: transparent;
      }
    }
    .counter-buttons-input {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      & input {
        background: transparent !important;
        border: unset !important;
        text-align: center !important;
        width: 30px;
        padding: 0;
      }
    }
    .label-info {
      font-family: Lato;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      letter-spacing: 0em;
      text-align: right;
    }
    .confirmation-modal {
      .modal-content {
        border-radius: 8px;
        width: 90%;
      }
      .modal-body {
        border-radius: 8px;
        min-height: 150px;
        background-color: white;
        & div {
          background-color: white;
          border-radius: 8px;
        }
        & p {
          color: black;
          text-align: center;
          padding: 0 10px;
          margin-bottom: 20px;
        }
      }
    }
    .rc-calendar {
      border-radius: 7px;
      .rc-calendar-header {
        background-color: #F4F4F4;
        a {
          font-family: Roboto;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0em;
          text-align: left;
          color: ${colors.mobileGreen}
        }
      }
      .rc-calendar-input-wrap {
        background-color: ${colors.mobileGreen};
        border-radius: 7px 7px 0 0;
        a {
          display: none;
        }
        .rc-calendar-clear-btn {
          display: none;
          background-color: ${colors.mobileGreen};
        }
      }
      .rc-calendar-date-input-wrap {
        color: transparent;
      }
      .rc-calendar-input {
        background: none;
        color: white;
      }
      .rc-calendar-body {
        & thead {
          & span {
            color: ${colors.mobileGreen}
          }
        }
      }
    }
    .button-single-modal {
      & button {
        font-family: Lato;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0em;
        text-align: right;
        background: none;
        width: 100%;
        height: 44px;
        text-align: center;
        padding: 12px 16px 12px 16px;
        border-radius: 4px;
        border: none;
      }
      & button {
        color: ${colors.mobileGreen};
      }
    }
    .create-order-modal {
      .modal-content {
        width: 90%;
      }
      .modal-footer {
        border: none;
      }
      .modal-header {
        border: none;
        color: black
      }
    }
  }
`;

export { modals };